import { useDestroy, useRotateLeft, useRotateRight } from '../hooks';

import { TurnRight, TurnLeft } from '../icons';

const Buttons = ({ upload, selected, deletable, rotatable }) => {
  const { bottomLeft, bottomRight, topRight /* topLeft */ } =
    useButtonPosition(upload);

  const destroy = useDestroy(upload);
  const rotateLeft = useRotateLeft(upload);
  const rotateRight = useRotateRight(upload);

  if (selected) {
    // When selected, *no* buttons are shown → return nothing
    return null;
  }
  return (
    <>
      {deletable && (
        <button
          style={{ ...squareButtonStyle, ...topRight }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 0.9)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
          onClick={destroy}
        >
          {'x'}
        </button>
      )}

      {rotatable && (
        <>
          <button
            style={{ ...circleButtonStyle, ...bottomLeft }}
            onClick={rotateRight}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 0.9)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
          >
            <TurnRight />
          </button>

          <button
            style={{ ...circleButtonStyle, ...bottomRight }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 0.9)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
            onClick={rotateLeft}
          >
            <TurnLeft />
          </button>
        </>
      )}
    </>
  );
};

const baseButtonStyle = {
  position: 'absolute',
  zIndex: 10,
  padding: '0.5rem',
  margin: '0.5rem',
  opacity: 0.5,
  transition: 'opacity 0.2s ease-in-out',
  backgroundColor: '#e5e7eb', // Tailwind .btn defaults (light gray)
  borderRadius: '0.25rem',
  border: 'none',
  cursor: 'pointer',
};

const circleButtonStyle = {
  ...baseButtonStyle,
  borderRadius: '9999px', // full circle
};

const squareButtonStyle = {
  ...baseButtonStyle,
  width: '2.5rem',
  height: '2.5rem',
};

const useButtonPosition = ({ orientation }) => {
  return {
    bottomLeft: { left: 0, bottom: 0 },
    bottomRight: { right: 0, bottom: 0 },
    topRight: { right: 0, top: 0 },
    topLeft: { left: 0, top: 0 },
  };
};

export default Buttons;
